export default __webpack_public_path__ + "static/media/MyLittlePony_02.9b2c7af5.png";